import { createAction, props } from '@ngrx/store';
import { NoFlyZone } from '../../models/geoasset.model';

export const loadingNoFlyZoneAssets = createAction(
  '[Geo Assets] loading no fly zone assets',
);

export const loadingNoFlyZoneAssetsSuccess = createAction(
  '[Geo Assets] loading No Fly Zone Assets data success',
  props<{ noFlyZones: NoFlyZone[] }>(),
);

export const loadingNoFlyZoneAssetsError = createAction(
  '[Geo Assets] loading No Fly Zone Assets data error',
  props<{ error: any }>(),
);

export const createNoFlyZoneAssets = createAction(
  '[Geo Assets] creating No Fly Zone Assets',
  props<{ noFlyZone: NoFlyZone }>(),
);

export const creatingNoFlyZoneAssetsSuccess = createAction(
  '[Geo Assets] creating No Fly Zone Assets success',
  props<{ noFlyZone: NoFlyZone }>(),
);

export const creatingNoFlyZoneAssetsError = createAction(
  '[Geo Assets] creating No Fly Zone Assets error',
  props<{ error: any }>(),
);

export const editNoFlyZone = createAction(
  '[Geo Assets] edit no fly zone',
  props<{ id: string; changes: Partial<NoFlyZone> }>(),
);

export const editNoFlyZoneSuccess = createAction(
  '[Geo Assets] edit no fly zone success',
  props<{ noFlyZone: NoFlyZone }>(),
);
export const editNoFlyZoneError = createAction(
  '[Geo Assets] edit no fly zone error',
  props<{ error: any }>(),
);
